import React from "react";
import { TouchableOpacity } from "react-native";
import { AddBookmark, RemoveBookmark } from "myplan/components/Icon";
import { Container, OuterContainer } from "./styles";

const BookmarkButton = ({ onPress = () => {}, isBookmarked = false }) => {
	const Icon = isBookmarked ? RemoveBookmark : AddBookmark;
	return (
		<OuterContainer>
			<TouchableOpacity onPress={onPress}>
				<Container pointerEvents="box-none">
					<Icon width={"50%"} height={"50%"} />
				</Container>
			</TouchableOpacity>
		</OuterContainer>
	);
};

export default BookmarkButton;
